import React, { Component } from "react";
import NumberFormat from "react-number-format";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import TasksItems from '../../tasks/tasksNumeralChildScore/TasksItems'
import TaskFormCreate from '../../tasks/tasksNumeralChildScore/FormCreate'
import Preloader from '../../../GeneralComponents/LoadingComponen'
import ReactHtmlParser from 'react-html-parser';

class Show extends Component {
  constructor(props) {
    super(props);
    this.token = document.querySelector("[name='csrf-token']").content;
    this.url_source = `/health/normativity_scores/${this.props.normativityScore.id}`,
    this.state = {
      id: "",
      idTask: "",
      register: {},
      idSubnumeral: "",
      dataNumerals: [],
      formUpdate: {
        calification: 0,
      },

      modeEdit: false,
      modal: false,
      loadFile: true,
      showTask: false,

      data: [],
      isLoaded: false,
      loadCalification: false,
      valueTotal: 0,
    };
  }

  componentDidMount = () => {
    this.loadData();
  }

  //add items
  updateData = (data) => {
    this.setState({
        data: [...this.state.data, data],
    })
  }

  //add update
  updateItem = task => {
        this.setState({
          data: this.state.data.map(item => {
            if (task.id === item.id) {
              return { ...item,
                description: task.description,
                due_date: task.due_date,
                name: task.name,
                state: task.state,
                //user_owner: {document: "1037660678", document_type: "Cédula de"},
                general_comments: task.general_comments.length,
                general_files: task.general_files.length,
                task_labels: task.task_labels,
                users: task.task_labels,
              }
            }
            return item;
          })
        });
  }


  loadData = () => {
    fetch(`/health/get_numeral_parents_score/${this.props.normativityScore.id}`, {
        method: 'GET', // or 'PUT'
        headers: {
            "X-CSRF-Token": this.token,
            "Content-Type": "application/json"
        }
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        data: data.data,
        valueTotal: data.valueTotal,
        loadCalification: false,
        isLoaded: true,
        id: "",
        formUpdate: {
          calification: 0,
        },
      });
    });
  }

  messageSuccess = (response) => {
    Swal.fire({
      position: "center",
      type: "success",
      title: `${response}`,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  HandleClickUpdate = (id) => {
    this.setState({ loadCalification: true })
    fetch(`/health/update_value/${id}/${this.state.formUpdate.calification}`, {
      method: "POST", // or 'PUT'
      headers: {
        "X-CSRF-Token": this.token,
        "Content-Type": "application/json"
      }
    })
      .then((response) => response.json())
      .then((data) => {
        this.loadData();
      });
  };

  clearValues = () => {
    this.setState({
      formNumeralFiles: {
        ...this.state.formNumeralFiles,
        description: "",
      },
      file_subnumeral: null,
    });
  };



  onChangeUpdate = (e) => {
    this.setState({
      formUpdate: {
        ...this.state.formUpdate,
        [e.target.name]: e.target.value,
      },
    });
  };

  updateValues = (id, value) => {
    this.setState({
      id: id,
      formUpdate: {
        calification: value,
      },
    });
  };

  closeTask = () => {
      this.setState({
        idTask: "",
        showTask: false,
      })
  }



  getColor(value) {
    let color = []
    if (value == 11)
    {
      color = ["gray", "white"];
    }
    else if (value < 6) {
      color = ["#ea4612", "white"];
    } else if (value >= 6 && value < 8) {
      color = ["orange", "white"];
    }
    else {
      color = ["#30af28", "white"];
    }

    var style = { color: color[1], background: color[0] }

    return style
  }

  getBack = (value) => {
    Turbolinks.visit(value, "_self")
  }


  getNameTitle = (name) => {
      if (typeof window !== "undefined" && window.GS_TYPE_NAMES && window.GS_TYPE_NAMES[name]) {
          return window.GS_TYPE_NAMES[name];
      }
      if(name == "PCH" || name == "NMH"){
          return "Hospitales"
      }else if(name == "PCCAP"){
          return "Modelo Ambulatorio"
      }else if(name == "PCISO9001"){
          return "ISO 9001:2015 Salud"
      }else if(name == "PCISO15189"){
          return "ISO 7101:2023 HQM"
      }else if(name == "PCHEM"){
          return "Acreditación"
      }else if(name == "NCON"){
          return "Servicios Auxiliares"
      }else if(name == "NFAR"){
          return "Expediente Clínico"
      }else if(name == "NNOM"){
          return "Marco Legal"
      }
  }

  // Badge grande para los TOTALES (por estándar y global), estilo original.
  renderScore = (value) => {
    const display = value != null ? (value != 11 ? value : "N/A") : 0;
    return (
      <span className="rk-score-badge" style={this.getColor(value != null ? value : 0)}>
        {display}
      </span>
    );
  }

  render() {
    // gestionmejora no restringe quién califica. El gate por responsable_user_id
    // escondía TODA la columna de calificación para los gestores/creador que no
    // fueran el responsable único, dejando la evaluación sin poder calificarse
    // (bug reportado). Permitimos calificar como en gestionmejora.
    const isResponsable = true;
    // Tablero Kanban de la evaluación (las tareas del pin caen en su 1ª columna).
    const board = this.props.normativityScore.task_board;

    return (
      <div className="rk-wrap">
        <nav className="rk-breadcrumb" aria-label="breadcrumb">
          <a href="javascript:void(0);" onClick={() => this.getBack(`/health/normativity?type=${this.props.normativityScore.normativity.type_normativity}`)}>
            {this.getNameTitle(this.props.normativityScore.normativity.type_normativity)}
          </a>
          <span className="rk-breadcrumb__sep">/</span>
          <a href="javascript:void(0);" onClick={() => this.getBack(`/health/normativity/${this.props.normativityScore.normativity.id}/numeral_parents`)}>
            Estándares y Guías
          </a>
          <span className="rk-breadcrumb__sep">/</span>
          <a href="javascript:void(0);" onClick={() => this.getBack(`/health/normativity/${this.props.normativityScore.normativity.id}/`)}>
            Evaluaciones
          </a>
          <span className="rk-breadcrumb__sep">/</span>
          <span className="rk-breadcrumb__current">
            Evaluaciones de {this.props.normativityScore.normativity.name}
          </span>
        </nav>

        {this.state.isLoaded ? (
          <React.Fragment>
            <div className="rk-panel" style={{ marginBottom: 16 }}>
              <div className="rk-panel__head">
                <i className="fas fa-clipboard-check rk-panel__icon"></i>
                <span>{this.props.normativityScore.normativity.name}</span>
              </div>
            </div>

            {this.state.data.map((accion) => (
              <div className="rk-panel" style={{ marginBottom: 16 }} key={accion.id}>
                <div className="rk-panel__head">
                  <i className="fas fa-shield-alt rk-panel__icon"></i>
                  <span>
                    <b>Estándar de Seguridad del Paciente: </b>
                    {accion.numeral_parent.patient_safety_standar}
                  </span>
                </div>

                <div className="rk-table-scroll">
                  <table className="rk-table">
                    <thead>
                      <tr>
                        <th>Elemento medible (Requisito)</th>
                        <th className="text-center rk-score-col">Calificación</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accion.numeral_child_scores.map((son) => (
                        <tr key={son.id}>
                          <td className="rk-cell-primary">
                            <i
                              id={`PopoverLabels${son.id}`}
                              onClick={() => this.setState({ showTask: true, idTask: son.id, register: son })}
                              className="fas fa-thumbtack float-right rk-inline-btn"
                              style={{ cursor: "pointer" }}
                              title="Crear tarea"
                            ></i>

                            <div>{ReactHtmlParser(son.measurable_element_child)}</div>

                            <UncontrolledPopover
                              isOpen={(this.state.showTask && this.state.idTask == son.id) ? true : false}
                              placement="bottom"
                              target={`PopoverLabels${son.id}`}
                            >
                              <PopoverHeader>
                                Crear tarea
                                <a className="close-popover" onClick={() => this.setState({ showTask: false, idTask: "", register: {} })}>
                                  <i className="fas fa-times"></i>
                                </a>
                              </PopoverHeader>
                              <PopoverBody>
                                <TaskFormCreate
                                  numeral_child_score={son.module_task_id}
                                  loadTasks={this.loadData}
                                  users={this.props.users}
                                  closeTask={this.closeTask}
                                  url_source={this.url_source}
                                  task_source_id={this.props.task_source.id}
                                  column_id={board ? board.first_column_id : ""}
                                  task_label_ids={accion.task_label_id ? [accion.task_label_id] : []}
                                />
                              </PopoverBody>
                            </UncontrolledPopover>

                            {son.tasks.length >= 1 ? <hr /> : ""}
                            {son.tasks.map((task) => (
                              <TasksItems
                                key={task.id}
                                task={task}
                                user={this.props.user}
                                users={this.props.users}
                                loadData={this.loadData}
                                procesos={this.props.procesos}
                                company={this.props.company}
                              />
                            ))}
                          </td>

                          <td className="text-center rk-score-col">
                            {isResponsable && (
                              this.state.id == son.id ? (
                                this.state.loadCalification ? (
                                  <div className="loader-wrapper d-flex justify-content-center align-items-center" style={{ width: "100%" }}>
                                    <div className="loader">
                                      <div className="ball-clip-rotate">
                                        <div style={{ backgroundColor: "rgb(68, 64, 84)" }}></div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <React.Fragment>
                                    <select
                                      name="calification"
                                      className="rk-input rk-input--inline"
                                      onChange={this.onChangeUpdate}
                                      value={this.state.formUpdate.calification}
                                    >
                                      <option value="0">0</option>
                                      <option value="5">5</option>
                                      <option value="10">10</option>
                                      <option value="11">N/A</option>
                                    </select>

                                    <div className="rk-inline-actions" style={{ justifyContent: "center", marginTop: 8 }}>
                                      <button
                                        className="rk-icon-btn rk-icon-btn--ok"
                                        title="Guardar"
                                        onClick={() => this.HandleClickUpdate(son.id)}
                                      >
                                        <i className="fas fa-check"></i>
                                      </button>
                                      <button
                                        className="rk-icon-btn rk-icon-btn--cancel"
                                        title="Cancelar"
                                        onClick={() => this.setState({ id: "" })}
                                      >
                                        <i className="fas fa-times"></i>
                                      </button>
                                    </div>
                                  </React.Fragment>
                                )
                              ) : (
                                <span
                                  className="rk-score-num"
                                  onClick={() => this.updateValues(son.id, son.score)}
                                >
                                  {son.score != null ? (son.score != 11 ? son.score : "N/A") : 0}
                                </span>
                              )
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="rk-total-row">
                        <td className="text-right rk-total-label">Total</td>
                        <td className="text-center rk-score-col">
                          {this.renderScore(accion.score)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            ))}

            <div className="rk-total-bar">
              <span className="rk-total-label">Total</span>
              {this.renderScore(this.state.valueTotal)}
            </div>
          </React.Fragment>
        ) : (
          <div className="text-center">
            <Preloader />
          </div>
        )}
      </div>
    );
  }
}

export default Show;
